export const getToken = () => localStorage.getItem("agentToken");

// Same call and error handling for both endpoints: throws, so the screen can show the error
// instead of receiving undefined (PlanDetailsAPI returns undefined on failure).
const get = async (path, failMessage) => {
  const token = getToken();
  const response = await fetch(path, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  });
  if (response.ok) {
    return response.json();
  }
  throw new Error(failMessage + " (" + response.status + ")");
};

// Read-only calls for the Totale Volumes and Weerstand Volumes screens.
export const VolumesAPI = {
  // The crop's pricing2 rows with the agent's own list/season prices already applied
  // (GET /api/volumes_pricing/{crop_id}). Includes resistance_discount_pct and resistance_price_pv.
  getVolumePricing: (cropId = 1) => get("/api/volumes_pricing/" + cropId, "Kon nie pryse laai nie"),

  // The default bundles for the crop, from table pricing2Dependants
  // (GET /api/resistance_bundles/{crop_id}).
  getResistanceBundles: (cropId = 1) => get("/api/resistance_bundles/" + cropId, "Kon nie die bundel laai nie"),
};

export default VolumesAPI;
